module.exports = __webpack_public_path__ + "img/volume.13e2d0f6.png";